export const messages = {
  title: '旅行攻略',
  categories: '分类',
  footprint: '足迹',
  allPlans: '全部',
  detail: '详情',
  empty: '暂无攻略',
  back: '返回列表',
  sections: '内容',
  info: '信息',
  list: '清单',
  timeline: '行程',
  routeMap: '路线',
  cards: '卡片'
} as const
